import { render } from "./DashboardTags.vue?vue&type=template&id=28f9122f"
import script from "./DashboardTags.vue?vue&type=script&lang=js"
export * from "./DashboardTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__